/**
 * Decide whether a failed API response should trigger a full-page /forbidden redirect.
 * Stale super-admin requests after switching into a tenant session must not hijack navigation.
 *
 * Filter / metadata endpoints used across modules must NOT kick the user off the page
 * when their role lacks that secondary module (e.g. Orders → branch list, Reports → cities).
 * Primary module access is still enforced by RouteAccessGuard + page-level permission checks.
 */
const NO_FORBIDDEN_REDIRECT_PATH_SNIPPETS = [
  "payment-methods/scope",
  "delivery-profiles/scope",
  "list-for-assignment",
  "branch/all",
  "branch/list",
  "branch-country/list",
  "branch/country",
  "region/list",
  "region/all",
  "city/list",
  "city/all",
  "customer/list",
  "customers/list",
  "promotion/list",
  "promotions/list",
  "coupon/list",
  "coupons/list",
  "category/list",
  "categories/list",
  "item/list",
  "items/list",
  "modifier/list",
  "modifiers/list",
  "app/versions",
  "brand/list",
  "brands/list",
  "role/list",
  "roles/list",
  "zone/list",
  "zones/list",
  "allergen",
  "ingredient",
  "customer/all",
  "gift",
  "integrations/my",
]

export const shouldRedirectToForbidden = (error, config = {}) => {
  if (config?.skipForbiddenRedirect === true) {
    return false
  }

  const requestUrl = String(
    config?.url || error?.config?.url || error?.response?.config?.url || ""
  ).toLowerCase()

  if (requestUrl.includes("superadmin/")) {
    return false
  }

  if (
    typeof sessionStorage !== "undefined" &&
    sessionStorage.getItem("tenantLoginRedirect") === "1"
  ) {
    return false
  }

  if (
    NO_FORBIDDEN_REDIRECT_PATH_SNIPPETS.some(snippet =>
      requestUrl.includes(snippet)
    )
  ) {
    return false
  }

  // Unpermissioned-style list GETs used as dropdowns across modules.
  if (/(^|\/)list(\?|$)/.test(requestUrl.split("?")[0])) {
    return false
  }

  return true
}

export const beginTenantLoginRedirect = () => {
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.setItem("tenantLoginRedirect", "1")
  }
}

export const completeTenantLoginRedirect = () => {
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem("tenantLoginRedirect")
  }
}
